<template>
  <Modal
    fullbelowsm
    :title="name"
    :primary-button="$t('datastore.connect')"
    :secondary-button="$t('cancel')"
    :secondary-button-disabled="loading"
    :primary-button-loading="loading"
    :primary-button-disabled="loading"
    @primary="onSaveClick"
    @secondary="onCancelClick"
  >
    <div class="sm:w-700 px-4">
      <DataAdapterConfiguration :type="type" :adapter="editData" ref="configuration" @update="payload = $event" />
    </div>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex';
import DataAdapterConfiguration from '../data-adapters/DataAdapterConfiguration.vue';

export default {
  name: 'ConnectDataAdapter',
  components: { DataAdapterConfiguration },
  props: {
    name: String,
    type: String,
    editData: Object,
  },
  data() {
    return {
      loading: false,
      payload: null,
    };
  },
  computed: {
    projectId() {
      return this.$route.params.projectId;
    },
  },
  methods: {
    ...mapActions(['createProjectDataAdapter', 'updateProjectDataAdapter']),
    async onSaveClick() {
      const valid = this.$refs.configuration.validate();
      if (!valid.valid) return;
      this.loading = true;
      const actionPayload = { project_id: this.projectId, ...this.payload };
      const response = this.editData ? await this.updateProjectDataAdapter({ ...actionPayload, adapter_type: this.editData.adapter_type }) : await this.createProjectDataAdapter(actionPayload);
      this.loading = false;
      if (!response) return;
      this.$emit('close');
      if (!this.editData) {
        this.$router.push({
          name: 'project-data-adapter-tools',
          params: {
            projectId: this.projectId,
            dataAdapter: response.adapter_type || actionPayload.type,
          },
        });
      }
    },
    onCancelClick() {
      this.$emit('close');
    },
  },
};
</script>
